import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const NotFound = () => (
    <div className="d-flex align-items-center justify-content-center flex-column" style={{ minHeight: '80vh' }}>
        <h2>404 - Page Not Found</h2>
        <p>The page you are looking for does not exist.</p>
        <Link to="/" className="btn btn-primary">Go to Home</Link>
    </div>
);

export default NotFound;